import { Component, OnInit, Renderer2, Inject, DOCUMENT } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UIBaseService } from '../app/common/services/uibase.service';
import { DataService } from './common/services/data.service';
import { SearchService } from '../app/common/services/search.service';
import { TranslateService } from '@ngx-translate/core';

import { LanguageService } from './common/services/language-service';

@Component({
    selector: 'cop-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

export class AppComponent implements OnInit {
  searchComponentBoolean: boolean = false;
  searchResultsStatus: boolean = false;
  publicPage: boolean = false;
  welcomePage: boolean = false;
  isIE: boolean = false;
  RequestedURL: string = ''
  searchPage: boolean = false;
  childPublicPage: boolean = false;
  getCodeVerifier: string = "";
  getCodeChallenge: string = "";
  feedbackForm: boolean = false;
  docsFeedbackForm: boolean = false;
  secondDocsFeedbackForm: boolean = false;
  getHideOtherComps: boolean = false;

  constructor(private idle: Idle, private router: Router,
    private _renderer2: Renderer2,
    private route: ActivatedRoute,
    private uiBase: UIBaseService, private ds: DataService,
    private search: SearchService,
    translate: TranslateService,
    private languageService: LanguageService,
    @Inject(DOCUMENT) private _document: Document) {
    //translate.setDefaultLang('fr');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    //  translate.use('fr');
    idle.setIdle(5);
    idle.setTimeout(7195); // Timeout the session after 2 hours.
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    // Navigate to home page after 2 hours so that interseptor takes user to Login page.
    idle.onTimeout.subscribe(() => this.router.navigate(['']));
    this.idle.watch();
  }


  ngOnInit(): void {
    this.RequestedURL = window.location.href;
    this.isIE = navigator.userAgent.indexOf("Trident/7") > -1;
    this.getSearchResultsPageStatus();

    if(this.RequestedURL.indexOf('public') > -1)
      this.publicPage = true;
    else
      this.publicPage = false;

    if(this.RequestedURL.indexOf('public/schedule') > -1) {
      this.publicPage = false;
      this.childPublicPage = true;
    }
    if(this.RequestedURL.indexOf('search') > -1) {
      this.searchPage = true;
    }
    if(this.RequestedURL.indexOf('welcome') > -1) {
      this.welcomePage = true;
    } else {
      this.welcomePage = false;
    }
    if(this.RequestedURL.indexOf('/online/feedback') > -1) {
      this.feedbackForm = true;
    }
    if(this.RequestedURL.indexOf('/docs/feedback') > -1) {
      this.docsFeedbackForm = true;
    }
    if(this.RequestedURL.indexOf('/documentation/feedback') > -1) {
      this.secondDocsFeedbackForm = true;
    }

    if(this.RequestedURL.indexOf('/public/myrequests?view=') > -1 || this.RequestedURL.indexOf('/public/history?view=') > -1 || this.RequestedURL.indexOf('/public/mycomprequests?view=') > -1) {
      this.getHideOtherComps = true;
    } else {
      this.getHideOtherComps = false;
    }

    // this.route.queryParamMap.subscribe((params: any) => {
    //   this.RequestedURL = window.location.href;
    //   setTimeout(() => {
    //     let myWindow = window as any;
    //     myWindow.sendObjectToChatBot({ hosting_url: this.RequestedURL });
    //   }, 1000);
    // });
  }

  getSearchResultsPageStatus() {
    this.search
      .getSearchResultsPageStatus()
      .subscribe((data: boolean) => {
        this.searchResultsStatus = data;
        // this.searchResultsStatus = true;
      });
  }
}
